var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('section',{staticClass:"tw-prose tw-prose-sm tw-prose-table:text-lg tw-max-w-none"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.markup)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }